export default __webpack_public_path__ + "static/media/booth_image@2x.84ba8e0e.jpg";